import { Box, Container } from "@mui/material";
import MainTemplate from "../../templates/MainTemplate";
import CreateTicketPage from "./CreateTicket";
import useBreakpoint from "../../../hooks/useBreakpoint";

export default function CreateMyTicketPage() {
  const breakpoint = useBreakpoint();
  // One stable tree for every width: only padding values respond to the
  // breakpoint, so rotating/resizing never remounts the form and typed
  // content is kept.
  return (
    <MainTemplate>
      <Box
        height={1}
        pt={breakpoint.md ? 4 : undefined}
        pb={breakpoint.md ? 4 : undefined}
        bgcolor="background.paper"
      >
        <Container disableGutters sx={{ p: 1 }}>
          <CreateTicketPage />
        </Container>
      </Box>
    </MainTemplate>
  );
}